import axios from "axios";
import { getActiveEnvironment } from "../services/environmentService";

// Configuración predeterminada (fallback)
export const enviroment = {
	company: "Santillana Ecuador",
	env: "Santillana_Ecuador",
	apiUrl: "https://usuarios-api.app.elingenierojefe.es",
	bcBaseUrl: "https://api.businesscentral.dynamics.com/v2.0/7516bb18-282c-4e63-b1ec-795805f1e8fd",
	grant_type: "client_credentials",
	client_secret: "ljO8Q~p4Ka8k3omAJc5cRUhSzhXR2hdOYg2kWcYu",
	client_id: "c6ecdbe2-1087-407d-9a0d-adf671cc102d",
	scope: "https://api.businesscentral.dynamics.com/.default",
	loginUrl: "https://login.microsoftonline.com/7516bb18-282c-4e63-b1ec-795805f1e8fd/oauth2/v2.0/token"
}

// Función auxiliar para verificar errores en el value
const checkValueForErrors = (value) => {
	if (typeof value === 'string' && value.toLowerCase().startsWith('error:')) {
		const errorMessage = value.substring(6).trim(); // Remover "error:" del inicio
		console.error('Error de Business Central:', errorMessage);
		alert(`Error en Business Central: ${errorMessage}`);
		return true;
	}
	return false;
};

// Obtener configuración activa del entorno
export const getCurrentEnvironment = async () => {
	try {
		const activeEnv = await getActiveEnvironment();
		if (!activeEnv) {
			throw new Error("No hay configuración de entorno disponible");
		}

		return {
			company: activeEnv.company,
			env: activeEnv.env,
			apiUrl: activeEnv.apiUrl,
			bcBaseUrl: activeEnv.bcBaseUrl,
			grant_type: activeEnv.grant_type || "client_credentials",
			client_secret: activeEnv.client_secret,
			client_id: activeEnv.client_id,
			scope: activeEnv.scope,
			loginUrl: activeEnv.loginUrl
		};
	} catch (error) {
		console.warn("No se pudo obtener configuración de entorno activa, usando configuración predeterminada:", error);
		return enviroment;
	}
};

export const getAuthToken = async () => {
	const env = await getCurrentEnvironment();
	const response = await axios.post(`${env.apiUrl}/token`, {
		grant_type: env.grant_type,
		client_secret: env.client_secret,
		client_id: env.client_id,
		scope: env.scope,
		loginUrl: env.loginUrl,
	});
	return response.data.token;
};

export const fetchFromBusinessCentral = async (endpoint) => {
	try {
		const env = await getCurrentEnvironment();
		const token = await getAuthToken();
		const BC_BASE_URL = `${env.bcBaseUrl}/${env.env}/ODataV4`;
		const url = `${BC_BASE_URL}/Company('${env.company}')/${endpoint}`;

		const response = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		});

		const value = response.data.value;

		// Verificar si hay error en el value
		if (checkValueForErrors(value)) {
			return "";
		}

		return value || [];
	} catch (error) {
		console.error(
			`Error al obtener datos de Business Central (${endpoint}):`,
			error
		);
		throw error;
	}
};

export const fetchFromBusinessCentralEspecial = async (endpoint, data = {}) => {
	try {
		const env = await getCurrentEnvironment();
		const token = await getAuthToken();
		const BC_BASE_URL = `${env.bcBaseUrl}/${env.env}/ODataV4`;
		const url = `${BC_BASE_URL}/${endpoint}?company='${env.company}'`;

		const response = await axios.post(url, data, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		});

		const value = response.data.value;

		// Verificar si hay error en el value
		if (checkValueForErrors(value)) {
			return "";
		}

		return value || [];
	} catch (error) {
		console.error(
			`Error al obtener datos de Business Central (${endpoint}):`,
			error
		);
		throw error;
	}
};

export const sendToBusinessCentral = async (
	endpoint,
	data,
	isCustomEndpoint = false
) => {
	try {
		const env = await getCurrentEnvironment();
		const token = await getAuthToken();
		const BC_BASE_URL = `${env.bcBaseUrl}/${env.env}/ODataV4`;

		let url;
		if (isCustomEndpoint) {
			url = `${BC_BASE_URL}/${endpoint}?company='${env.company}'`;
		} else {
			url = `${BC_BASE_URL}/Company('${env.company}')/${endpoint}`;
		}

		const response = await axios.post(url, data, {
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
		});

		const responseData = response.data;

		// Verificar si hay error en el value del response
		if (responseData.value && checkValueForErrors(responseData.value)) {
			return { ...responseData, value: "" };
		}

		return responseData;
	} catch (error) {
		console.error(
			`Error al enviar datos a Business Central (${endpoint}):`,
			error
		);
		throw error;
	}
};
